import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AppConfigService } from 'src/app/Services/app-config.service';
//import { MAT_ICON_DEFAULT_OPTIONS, MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-excursion-dialog',
  templateUrl: './excursion-dialog.component.html',
  styleUrls: ['./excursion-dialog.component.css'],
})
export class ExcursionDialogComponent {
  imagepath = '';
  //public alertMessage: string = 'test';
  constructor(
    private appConfigService: AppConfigService,
    public dialogRef: MatDialogRef<ExcursionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  clickclose(): void {
    this.dialogRef.close();
  }
}
